import { Dialog, DialogContent } from "@mui/material"
import { alertConfirmDelete } from "components/Alert"
import { BoxFC } from "components/BoxCustom"
import FilePreviewCard from "components/FileUplaod/FilePreviewCard"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import { resizeImage } from "utils/resizeImage"
import React, { useCallback, useContext, useEffect, useState } from "react"

const DriverAttendImageDialog = ({ selectedDrvAttnId, dialogOpen, setDialogOpen }) => {

  const { ax } = useContext(GlobalStateContext)
  const [filesData, setFilesData] = useState([])
  const [pendingFiles, setPendingFiles] = useState([])

  const loadFiles = useCallback(() => {
    if (!selectedDrvAttnId) return
    ax.post("/driver-attend/getDriverCheckInFile", { DrvAttnId: selectedDrvAttnId }).then(value => {
      if (value.data) {
        setFilesData(value.data)
      }
    })
  }, [ax, selectedDrvAttnId])

  const handleDeleteServerFile = useCallback((file) => {
    return new Promise((resolve) => {
      alertConfirmDelete(() => {
        ax.post("/driver-attend/deleteFile", { DrvChkInFileId: file.DrvChkInFileId }).then(value => {
          if (value.data) {
            resolve()
          }
        })
      })
    })
  }, [ax])

  const handleDialogOk = useCallback(async () => {
    for (const pf of pendingFiles) {
      const resizedFile = await resizeImage(pf.file, { maxWidth: 1500, maxHeight: 1500, quality: 85 })
      const formData = new FormData()
      formData.append("file", resizedFile)
      formData.append("DrvAttnId", selectedDrvAttnId)
      formData.append("FileTyp", "O")
      formData.append("Label", pf.name)
      await ax.post("/driver-attend/uploadFile", formData)
    }
    setPendingFiles([])
    setDialogOpen(false)
  }, [ax, pendingFiles, selectedDrvAttnId, setDialogOpen])

  useEffect(() => {
    if (dialogOpen) {
      loadFiles()
    } else {
      setFilesData([])
      setPendingFiles(o => {
        o.forEach(f => URL.revokeObjectURL(f.preview))
        return []
      })
    }
  }, [dialogOpen, loadFiles])

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="sm" >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รูปภาพการลงเวลา"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC mt={2} height={500}>
          <FilePreviewCard
            filesData={filesData}
            setFilesData={setFilesData}
            pendingFiles={pendingFiles}
            setPendingFiles={setPendingFiles}
            onDeleteServerFile={handleDeleteServerFile}
            fileIdKey="DrvChkInFileId"
          />
        </BoxFC>
      </DialogContent>
      <DialogFooter okText="บันทึก"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(DriverAttendImageDialog)
